import React, { useEffect, useState } from 'react';
import { CheckCircle2, Gift, BookOpen, Utensils, ShoppingCart, Calendar, Coffee, Moon, Lock } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  const checkoutUrl = 'https://pay.hotmart.com/F104765975P?checkoutMode=10';
  const discountCheckoutUrl = 'https://pay.hotmart.com/F104765975P?off=9ejqig6u&checkoutMode=10';
  // Check if the 24h offer has already expired on mount
  const [is24hExpired, setIs24hExpired] = useState(() => {
    const storedEndTime = localStorage.getItem('cenas_offer_end_time');
    if (storedEndTime) {
      return new Date().getTime() > parseInt(storedEndTime, 10);
    }
    return false;
  });
  const [is5minExpired, setIs5minExpired] = useState(() => {
    const storedEndTime = localStorage.getItem('cenas_offer_5min_end_time');
    if (storedEndTime) {
      return new Date().getTime() > parseInt(storedEndTime, 10);
    }
    return false;
  });
  const handle24hExpire = () => {
    setIs24hExpired(true);
  };
  const handle5minExpire = () => {
    setIs5minExpired(true);
  };
  return <section id="offer-section" className="py-16 md:py-24 px-4 bg-white relative scroll-mt-10" data-id="element-175">
      <div className="max-w-4xl mx-auto" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-forest mb-4" data-id="element-178">
            Todo Lo Que Incluye Tu Protocolo Completo
          </h2>
          <p className="text-lg text-dark/60" data-id="element-179">
            El stack de transformación nocturna más completo
          </p>
        </div>

        {/* Main Product */}
        <div className="bg-cream p-6 md:p-8 rounded-2xl border-2 border-forest/20 shadow-sm mb-8 relative overflow-hidden" data-id="element-180">
          <div className="absolute top-0 right-0 bg-forest text-white px-4 py-1 rounded-bl-xl font-bold text-sm" data-id="element-181">
            PRODUCTO PRINCIPAL
          </div>
          <div className="flex flex-col md:flex-row gap-6 items-center md:items-start" data-id="element-182">
            <div className="w-24 h-24 bg-white rounded-xl shadow-sm flex items-center justify-center shrink-0 border border-forest/10" data-id="element-183">
              <BookOpen size={40} className="text-forest" data-id="element-184" />
            </div>
            <div data-id="element-185">
              <h3 className="font-serif text-2xl font-bold text-forest mb-2" data-id="element-186">
                Cenas Anti-Inflamatorias en 15 Minutos — Guía Maestra (PDF)
              </h3>
              <p className="text-dark/70 mb-4" data-id="element-187">
                La guía completa de 70+ páginas que incluye:
              </p>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-dark/80" data-id="element-188">
                <li className="flex items-start gap-2" data-id="element-189">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-190" />{' '}
                  El Método de Digestión en Reposo
                </li>
                <li className="flex items-start gap-2" data-id="element-191">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-192" />{' '}
                  Los 7 Pilares de la Cena
                </li>
                <li className="flex items-start gap-2" data-id="element-193">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-194" />{' '}
                  El sistema del Plato 50-25-25
                </li>
                <li className="flex items-start gap-2" data-id="element-195">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-196" />{' '}
                  Los 8 culpables ocultos
                </li>
                <li className="flex items-start gap-2" data-id="element-197">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-198" />{' '}
                  Guía de especias carminativas
                </li>
                <li className="flex items-start gap-2" data-id="element-199">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-200" />{' '}
                  Protocolo de Timing Digestivo
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-201">
          {/* Bonus 1 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-202">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-203">
              B1
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-204">
              <Utensils className="text-gold" size={24} data-id="element-205" />
              <h4 className="font-bold text-lg text-forest" data-id="element-206">
                Recetario Maestro 21 Cenas
              </h4>
            </div>
            <p className="text-sm text-dark/70 mb-3" data-id="element-207">
              21 recetas organizadas en 4 categorías (Mar, Aves, Vegetales,
              Huevo). Máximo 15 minutos.
            </p>
            <ul className="text-sm text-dark/80 space-y-1" data-id="element-208">
              <li className="flex items-center gap-2" data-id="element-209">
                <CheckCircle2 size={14} className="text-success" data-id="element-210" /> Lista de
                ingredientes exacta
              </li>
              <li className="flex items-center gap-2" data-id="element-211">
                <CheckCircle2 size={14} className="text-success" data-id="element-212" /> Pasos con
                tiempos reales
              </li>
              <li className="flex items-center gap-2" data-id="element-213">
                <CheckCircle2 size={14} className="text-success" data-id="element-214" /> Variante
                rápida de emergencia
              </li>
            </ul>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-215">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-216">
              B2
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-217">
              <ShoppingCart className="text-gold" size={24} data-id="element-218" />
              <h4 className="font-bold text-lg text-forest" data-id="element-219">
                Checklist de Despensa
              </h4>
            </div>
            <p className="text-sm text-dark/70 mb-3" data-id="element-220">
              Tu mapa de compras definitivo para una cocina anti-inflamatoria.
            </p>
            <ul className="text-sm text-dark/80 space-y-1" data-id="element-221">
              <li className="flex items-center gap-2" data-id="element-222">
                <CheckCircle2 size={14} className="text-success" data-id="element-223" /> Qué eliminar
                hoy mismo
              </li>
              <li className="flex items-center gap-2" data-id="element-224">
                <CheckCircle2 size={14} className="text-success" data-id="element-225" /> 25
                ingredientes básicos
              </li>
              <li className="flex items-center gap-2" data-id="element-226">
                <CheckCircle2 size={14} className="text-success" data-id="element-227" /> Guía de
                etiquetado en súper
              </li>
            </ul>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-228">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-229">
              B3
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-230">
              <Calendar className="text-gold" size={24} data-id="element-231" />
              <h4 className="font-bold text-lg text-forest" data-id="element-232">
                Planificador Semanal
              </h4>
            </div>
            <ul className="text-sm text-dark/80 space-y-1 mt-2" data-id="element-233">
              <li className="flex items-center gap-2" data-id="element-234">
                <CheckCircle2 size={14} className="text-success" data-id="element-235" /> Plantilla de
                7 días imprimible
              </li>
              <li className="flex items-center gap-2" data-id="element-236">
                <CheckCircle2 size={14} className="text-success" data-id="element-237" /> Seguimiento
                de síntomas
              </li>
              <li className="flex items-center gap-2" data-id="element-238">
                <CheckCircle2 size={14} className="text-success" data-id="element-239" /> Escala de
                inflamación matutina
              </li>
            </ul>
          </div>

          {/* Bonus 4 & 5 Combined */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-240">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-241">
              B4+5
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-242">
              <Coffee className="text-gold" size={24} data-id="element-243" />
              <h4 className="font-bold text-lg text-forest" data-id="element-244">
                Infusiones & Ritual
              </h4>
            </div>
            <ul className="text-sm text-dark/80 space-y-1 mt-2" data-id="element-245">
              <li className="flex items-center gap-2" data-id="element-246">
                <CheckCircle2 size={14} className="text-success" data-id="element-247" /> 5 infusiones
                post-cena eficaces
              </li>
              <li className="flex items-center gap-2" data-id="element-248">
                <CheckCircle2 size={14} className="text-success" data-id="element-249" /> Ritual de
                cierre de 30 min
              </li>
              <li className="flex items-center gap-2" data-id="element-250">
                <CheckCircle2 size={14} className="text-success" data-id="element-251" /> Respiración
                4-7-8 anti-cortisol
              </li>
            </ul>
          </div>
        </div>

        {/* SUPER LLAMATIVA OFFER STACK */}
        <div className="bg-forest rounded-3xl p-1 shadow-2xl relative overflow-hidden mt-20" data-id="element-252">
          <div className="absolute inset-0 bg-gradient-to-r from-gold via-white to-gold opacity-30 animate-[spin_4s_linear_infinite] scale-150" data-id="element-253"></div>

          <div className="bg-cream rounded-[22px] p-6 md:p-10 relative z-10" data-id="element-254">
            <div className="text-center mb-8" data-id="element-255">
              <h3 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-2" data-id="element-256">
                Resumen de tu Inversión
              </h3>
              <p className="text-dark/60" data-id="element-257">Todo lo que te llevas hoy</p>
            </div>

            <div className="space-y-3 mb-8 max-w-lg mx-auto" data-id="element-258">
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-259">
                <span className="text-dark/80 font-medium" data-id="element-260">
                  Guía Maestra Anti-Inflamatoria
                </span>
                <span className="text-dark/50 line-through" data-id="element-261">$47.00 USD</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-262">
                <span className="text-dark/80 font-medium" data-id="element-263">
                  Recetario Maestro 21 Cenas
                </span>
                <span className="text-dark/50 line-through" data-id="element-264">$27.00 USD</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-265">
                <span className="text-dark/80 font-medium" data-id="element-266">
                  Checklist Despensa
                </span>
                <span className="text-dark/50 line-through" data-id="element-267">$17.00 USD</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-268">
                <span className="text-dark/80 font-medium" data-id="element-269">
                  Planificador Semanal
                </span>
                <span className="text-dark/50 line-through" data-id="element-270">$12.00 USD</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-271">
                <span className="text-dark/80 font-medium" data-id="element-272">
                  Guía de Infusiones
                </span>
                <span className="text-dark/50 line-through" data-id="element-273">$17.00 USD</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-274">
                <span className="text-dark/80 font-medium" data-id="element-275">
                  Ritual de Cierre 30 Minutos
                </span>
                <span className="text-dark/50 line-through" data-id="element-276">$17.00 USD</span>
              </div>
              <div className="flex justify-between items-center pt-2" data-id="element-277">
                <span className="text-forest font-bold text-lg" data-id="element-278">
                  VALOR TOTAL REAL:
                </span>
                <span className="text-urgency font-bold text-xl line-through" data-id="element-279">
                  $137.00 USD
                </span>
              </div>
            </div>

            {/* ═══════════════════════════════════ */}
            {/* PRICING BOX — TWO PHASES           */}
            {/* ═══════════════════════════════════ */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-gold text-center relative" data-id="element-280">
              {!is24hExpired /* ── PHASE 1: 24-hour offer active ── */ ? <>
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-urgency text-white px-4 py-1 rounded-full font-bold text-sm shadow-md animate-bounce" data-id="element-281">
                    ¡95% DE DESCUENTO!
                  </div>

                  <p className="text-dark/70 font-medium mb-2 mt-2" data-id="element-282">
                    Precio de Lanzamiento Especial:
                  </p>

                  <div className="flex items-center justify-center gap-4 mb-6" data-id="element-283">
                    <span className="text-3xl text-dark/40 line-through font-bold" data-id="element-284">
                      $29.00
                    </span>
                    <span className="text-6xl md:text-7xl font-serif font-bold text-forest drop-shadow-sm" data-id="element-285">
                      $6.39 <span className="text-2xl text-forest/70" data-id="element-286">USD</span>
                    </span>
                  </div>

                  <div className="bg-forest/5 rounded-xl p-4 mb-8 text-sm text-dark/80 flex items-center justify-center gap-2" data-id="element-287">
                    <Gift size={18} className="text-gold" data-id="element-288" />
                    <span data-id="element-289">
                      Incluye derecho a{' '}
                      <strong data-id="element-290">recibir todas las actualizaciones futuras</strong>{' '}
                      gratis.
                    </span>
                  </div>

                  <CountdownTimer theme="light" className="mb-8" storageKey="cenas_offer_end_time" durationMs={24 * 60 * 60 * 1000} onExpire={handle24hExpire} data-id="element-291" />

                  <CTAButton text="SÍ, QUIERO MI PROTOCOLO AHORA" href={checkoutUrl} variant="urgency" className="text-xl md:text-2xl py-5" data-id="element-292" />

                  <p className="text-xs text-dark/50 mt-4" data-id="element-293">
                    Acceso inmediato • Descarga instantánea • Garantía 30 días
                  </p>
                </> /* ── PHASE 2: 24h expired → 5-min last chance ── */ : <>
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-urgency text-white px-4 py-1 rounded-full font-bold text-sm shadow-md animate-pulse" data-id="element-294">
                    ⏰ ÚLTIMA OPORTUNIDAD
                  </div>

                  {/* Struck-through old price */}
                  <div className="flex items-center justify-center gap-4 mb-6 mt-4" data-id="element-295">
                    <span className="text-3xl text-dark/30 line-through font-bold" data-id="element-296">
                      $29.00
                    </span>
                    <span className="text-5xl md:text-6xl font-serif font-bold text-dark/30 line-through drop-shadow-sm" data-id="element-297">
                      $6.39 <span className="text-xl text-dark/20" data-id="element-298">USD</span>
                    </span>
                  </div>

                  {/* Expiry copy */}
                  <div className="bg-urgency/5 border border-urgency/20 rounded-xl p-6 mb-8 text-left space-y-4" data-id="element-299">
                    <p className="text-lg font-bold text-urgency text-center" data-id="element-300">
                      ⏰ La oferta de $6.39 ha expirado.
                    </p>
                    <p className="text-dark/80 leading-relaxed" data-id="element-301">
                      Si sigues aquí es porque esto es para ti. Y lo sé.
                    </p>
                    <p className="text-dark/80 leading-relaxed" data-id="element-302">
                      Así que por los próximos{' '}
                      <strong className="text-forest" data-id="element-303">5 minutos</strong> te
                      activo un precio especial de{' '}
                      <strong className="text-forest text-xl" data-id="element-304">$9.99 USD</strong>
                      .
                    </p>
                    <p className="text-dark/80 leading-relaxed" data-id="element-305">
                      Cuando este contador llegue a cero, el precio sube a{' '}
                      <strong className="text-urgency" data-id="element-306">$39.00 USD</strong> y ya
                      no habrá más descuentos.
                    </p>
                    <p className="text-dark font-bold text-center" data-id="element-307">
                      No es broma. No hay tercer contador. Toma esta oportunidad
                      ahora.
                    </p>
                  </div>

                  {/* New price display */}
                  <div className="flex items-center justify-center gap-4 mb-6" data-id="element-308">
                    <span className="text-2xl text-dark/40 line-through font-bold" data-id="element-309">
                      $39.00
                    </span>
                    <span className="text-6xl md:text-7xl font-serif font-bold text-forest drop-shadow-sm" data-id="element-310">
                      $9.99 <span className="text-2xl text-forest/70" data-id="element-311">USD</span>
                    </span>
                  </div>

                  {/* 5-minute countdown */}
                  {!is5minExpired ? <>
                      <CountdownTimer theme="light" className="mb-8" storageKey="cenas_offer_5min_end_time" durationMs={5 * 60 * 1000} onExpire={handle5minExpire} expiredMessage="TIEMPO AGOTADO — El precio ha subido a $39.00 USD" data-id="element-312" />

                      <CTAButton text="SÍ, QUIERO ACCEDER CON DESCUENTO" href={discountCheckoutUrl} variant="urgency" className="text-xl md:text-2xl py-5" data-id="element-313" />

                      <div className="flex items-center justify-center gap-3 mt-4 text-sm text-dark/60" data-id="element-314">
                        <Lock size={14} className="text-forest" data-id="element-315" />
                        <span data-id="element-316">
                          Pago seguro · Acceso inmediato · Garantía 7 días
                        </span>
                      </div>
                    </> : <div className="text-center py-4" data-id="element-317">
                      <div className="text-xl font-bold text-urgency bg-red-50 border-2 border-urgency rounded-lg py-4 px-6 mb-6" data-id="element-318">
                        TIEMPO AGOTADO — El precio ha subido a $39.00 USD
                      </div>
                      <CTAButton text="ACCEDER POR $39.00 USD" href={checkoutUrl} variant="primary" className="text-xl py-5" data-id="element-319" />
                    </div>}
                </>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}